import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import OnBoarding from "./OnBoarding";
import SignIn from "../Auth/SignIn";

const wait = (ms = 100) => {
  return new Promise((res, rej) => {
    setTimeout(() => {
      res(true);
    }, ms);
  });
};

export default function OnBoarding1() {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    wait(800).finally(() => {
      setShowLoader(false);
    });
  }, []);

  return showLoader ? (
    <OnBoarding />
  ) : (
    <div className="onboarding-container">
      <div className="onboard-content d-flex">
        <div className="empoweredman-image"></div>
        <div className="get-started">
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <div>
              <img
                style={{ width: "109.35px", height: "123.93px" }}
                src="/images/brave.png"
                alt=""
              />
            </div>
            <div
              className="d-flex flex-column"
              style={{ gap: "32px", marginTop: "32px" }}
            >
              <div className="d-flex flex-column" style={{ gap: "12px" }}>
                <h1
                  className="text-heading-h1"
                  style={{ color: "rgba(230, 236, 241, 1)" }}
                >
                  Welcome To <br /> Empowered Man!
                </h1>
                <span
                  className="text-body-b2"
                  style={{ color: "rgba(230, 236, 241, 1)" }}
                >
                  Your personal power weapon
                </span>
              </div>
              {/*<div>*/}
              {/*  <Link to="/onboarding" className="get-started-link">*/}
              {/*    <button*/}
              {/*      className="get-started-btn"*/}
              {/*      style={{ width: "240px" }}*/}
              {/*    >*/}
              {/*      Get Started*/}
              {/*    </button>*/}
              {/*  </Link>*/}
              {/*</div>*/}
              <SignIn/>
              <div>
                <span
                  style={{
                    color: "rgba(208, 216, 223, 1)",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "14px",
                    cursor: "pointer",
                  }}
                >
                  Create an Account?{" "}
                  <span style={{ color: "rgba(102, 186, 255, 1)" }}>
                    <Link to="/sign-up" className="sign-in-link">
                      Sign Up
                    </Link>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
